<template>
  <div class="card">
    <div class="delivery">
      <div class="card-box">
        <h1 style="font-weight: bold;">物料编号：{{ complaint.materialCode }}</h1>
        <div>用途：{{ complaint.usageName }}</div>
        <div>产品名称：{{ complaint.commodityName }}</div>
        <div>生产企业：{{ complaint.manufacturer }}</div>
        <div>规格牌号：{{ complaint.spec }}</div>
        <div>产品等级：{{ complaint.grade }}</div>
        <div>月需求计划量：{{ complaint.monthDemandWeight }}</div>
      </div>
    </div>
  </div>
</template>
<script>
// import orderApi from "@/request/orderApi";
export default {
  name: "QualificationCard",
  props: {
    // order: Object,
    complaint: Object
  },
  data() {
    return {
      qualificationList: []
    };
  },
  computed: {},
  methods: {
    toDetails() {
      this.$router.push("/qualificationDetails");
    }
  },
};
</script>
<style lang="stylus" scoped>
.card {
  margin: 32px 0;
  padding: 0 32px;

  .card-box {
    padding: 32px;
    background: #ffffff;
    border-radius: 20px;

    h1 {
      margin-bottom: 30px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #333333;
    }

    div {
      margin-top: 16px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #666666;
    }
  }
}
</style>